module.exports = "<div class=\"button-image-container\">\n  <div class=\"button-image\" [style.background-image]=\"'url(' + button.url + ')'\">\n    <img [src]=\"button.url\" (load)=\"imageLoaded()\">\n  </div>\n  <div class=\"button-label\" *ngIf=\"showLabel\"> {{ button.name }}</div>\n  <div class=\"image-spinner\" [hidden]=\"hideSpinner\"><i class=\"fas fa-spinner fa-spin\"></i></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button-image/button-image.component.html
// module id = ./src/app/shared/button-image/button-image.component.html
// module chunks = main